import React from 'react';
import { RenderFaston6_3Alt as RenderFaston63Alt } from './RenderFaston6_3Alt';

export const RenderFastonCovered6_3Alt = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
      {/* Base Faston - We pass x=0, y=0, scale=1, rotate=0 because we already applied the transformations in the parent <g> */}
      <RenderFaston63Alt color={color} x={0} y={0} scale={1} side={side} rotate={0} />

      {/* Cover SVG */}
      <g>
        <g transform="translate(-350, -150)">
          <g transform="translate(371, 150) scale(1.2) translate(-400, -150)">
            <g transform="translate(143, 544) matrix(-0.260805, 0, 0, -0.260805, 557.00068, -261.815342) translate(-143, -544)">

              <g transform="matrix(1, 0, 0, 1, 1485.000022, 1050.000016)" fillOpacity="1" fillRule="evenodd">
                <path d="M-1342,-440 C-1342,-476.451 -1312.45,-506 -1276,-506 L346.5,-506 L1287,-506 C1317.38,-506 1342,-481.376 1342,-451 L1342,-440 L1342,440 L1342,451 C1342,481.376 1317.38,506 1287,506 L346.5,506 L-1276,506 C-1293.5,506 -1310.29,499.046 -1322.67,486.669 C-1335.05,474.292 -1342,457.504 -1342,440 L-1342,-440" fill="#ffffff" fillOpacity="0.50" />
                <path d="M-1276,-440 L319,-440 L319,440 L-1276,440 L-1276,-440" fill="#ffffff" fillOpacity="0.50" />
                <path d="M346.5,-440 L1287,-440 L1287,440 L346.5,440 L346.5,-440" fill="#ffffff" fillOpacity="0.50" />
                <path d="M319,-478.5 C319,-493.688 331.312,-506 346.5,-506 L-1276,-506 L-1276,-440 L319,-440 L319,-478.5" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M346.5,506 L-1276,506 L-1276,440 L319,440 L319,478.5 C319,493.688 331.312,506 346.5,506" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M1287,-506 L346.5,-506 L346.5,-440 L1287,-440 L1287,-506" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M1287,440 L1287,506 L346.5,506 L346.5,440 L1287,440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M-1276,-440 L-1276,440 L-1342,440 L-1342,-440 L-1322.67,-440 L-1276,-440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M1342,-440 L1342,440 L1287,440 L1287,-440 L1342,-440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M1342,440 L1287,440 L1287,506 C1317.38,506 1342,481.376 1342,451 L1342,440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M1342,-440 L1342,-451 C1342,-481.376 1317.38,-506 1287,-506 L1287,-440 L1342,-440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M-1276,-506 L-1276,-440 L-1322.67,-440 C-1322.67,-476.451 -1301.77,-506 -1276,-506" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M-1322.67,486.669 C-1335.05,474.292 -1342,457.504 -1342,440 L-1276,440 L-1322.67,486.669" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M-1276,440 L-1276,506 C-1293.5,506 -1310.29,499.046 -1322.67,486.669 L-1276,440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M-1322.67,-440 L-1342,-440 C-1342,-476.451 -1312.45,-506 -1276,-506 C-1301.77,-506 -1322.67,-476.451 -1322.67,-440" fill="#e0e0e0" fillOpacity="0.95" />
                <path d="M319,-440 L319,440 L319,478.5 C319,493.688 331.312,506 346.5,506 L346.5,440 L346.5,-440 L319,-440" fill="#e0e0e0" fillOpacity="1" />
                <path d="M319,-478.5 C319,-493.688 331.312,-506 346.5,-506 L346.5,-440 L319,-440 L319,-478.5" fill="#e0e0e0" fillOpacity="1" />
              </g>

              <g transform="matrix(1, 0, 0, 1, 1485.000022, 1050.000016)" fill="none">
                <g stroke="#999999" strokeOpacity="0.5" strokeWidth="4" strokeLinejoin="bevel" strokeLinecap="round">
                  <path d="M-1276,-506 L-1276,-440" />
                  <path d="M-1276,440 L-1276,506" />
                  <path d="M-1322.67,-440 L-1342,-440" />
                  <path d="M-1322.67,-440 C-1322.67,-476.451 -1301.77,-506 -1276,-506" />
                  <path d="M-1322.67,486.669 L-1276,440" />
                  <path d="M1287,-506 L1287,-440" />
                  <path d="M1287,-440 L1287,440" stroke="#212529" />
                  <path d="M1287,440 L1287,506" />
                  <path d="M1342,-440 L1287,-440" />
                  <path d="M1342,440 L1287,440" />
                  <path d="M 319 -440 L 319 440 M 319 440 L 319 478.5 M 319 -478.5 L 319 -440" stroke="#212529" strokeWidth="7" strokeOpacity="1" />
                  <path d="M346.5,-506 L346.5,-440" />
                  <path d="M346.5,-440 L346.5,440" stroke="#212529" />
                  <path d="M346.5,440 L346.5,506" />
                  <path d="M-1276,-440 L319,-440" stroke="#212529" />
                  <path d="M 319 440 L -1276 440" stroke="#212529" />
                  <path d="M -1276 440 L -1342 440" />
                  <path d="M346.5,-440 L1287,-440" stroke="#212529" />
                  <path d="M1287,440 L346.5,440" stroke="#212529" />
                  <path d="M-1276,-440 L-1322.67,-440" />
                  <path d="M-1276,-440 L-1276,440" stroke="#212529" />
                </g>
                <g stroke="#212529" strokeOpacity="1" strokeWidth="7" strokeLinejoin="bevel" strokeLinecap="round">
                  <path d="M-1342,-440 C-1342,-476.451 -1312.45,-506 -1276,-506" />
                  <path d="M-1322.67,486.669 C-1335.05,474.292 -1342,457.504 -1342,440" />
                  <path d="M1287,506 C1317.38,506 1342,481.376 1342,451" />
                  <path d="M1342,-440 L1342,-451" />
                  <path d="M1342,-440 L1342,440" />
                  <path d="M1342,440 L1342,451" />
                  <path d="M1287,-506 C1317.38,-506 1342,-481.376 1342,-451" />
                  <path d="M346.5,-506 L-1276,-506" />
                  <path d="M1287,-506 L346.5,-506" />
                  <path d="M1287,506 L346.5,506" />
                  <path d="M346.5,506 L-1276,506" />
                  <path d="M319,-478.5 C319,-493.688 331.312,-506 346.5,-506" />
                  <path d="M319,478.5 C319,493.688 331.312,506 346.5,506" />
                  <path d="M-1276,506 C-1293.5,506 -1310.29,499.046 -1322.67,486.669" />
                  <path d="M-1342,-440 L-1342,440" />
                  <path d="M1287,-506 C1317.38,-506 1342,-481.376 1342,-451" />
                  <path d="M1342,451 C1342,481.376 1317.38,506 1287,506" />
                  <path d="M-1322.67,-440 C-1322.67,-476.451 -1301.77,-506 -1276,-506" stroke="#999999" strokeOpacity="0.5" strokeWidth="4" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  );
};
